import type { ExecutorchLlmService } from "$src/core/services/search-classification/types";

const ExecutorchLlm: ExecutorchLlmService = {
  status: "unavailable",
  classify: async () => null,
  startDownload: async () => undefined,
  getDownload: async () => "missing",
  deleteDownload: async () => undefined,
  addDownloadProgressListener: () => () => undefined,
};

export default ExecutorchLlm;
